export default __webpack_public_path__ + "static/media/into-the-valley.944967c5.mp4";